import { render, staticRenderFns } from "./plansFooter.vue?vue&type=template&id=7f23db9a&scoped=true&"
import script from "./plansFooter.vue?vue&type=script&lang=js&"
export * from "./plansFooter.vue?vue&type=script&lang=js&"
import style0 from "./plansFooter.vue?vue&type=style&index=0&id=7f23db9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23db9a",
  null
  
)

export default component.exports